import { Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AgreementProductsReckoningTable } from "./AgreementProductsReckoningTable";
import { AgreementProductsTable } from "./AgreementProductsTable";
import { FinalSettlementButton } from "./FinalSettlementButton";

export const ProductsTab = (props) => {
    const { agreementId, agreementFinalSettlement, isInvestmentEffectiveFootageFilled, agreementKind, products, readOnly } = props;
    const { t } = useTranslation();

    return (
        <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
                <Grid item xs={12}>
                    <Typography variant="h6" component="h3">
                        {t("agreements.AgreementProductsTab.selectedProducts")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, mx: "auto", overflowY: "auto", maxHeight: "40vh" }}>
                        <AgreementProductsTable
                            products={products}
                            showTotalsAfterDiscount={true}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid item xs={12} sx={{display: "flex", justifyContent:"center"}}>
                    <Typography variant="h6" component="h3">
                        {t("agreements.AgreementProductsTab.reckoning")}
                    </Typography>
                    <FinalSettlementButton 
                        agreementId={agreementId}
                        agreementFinalSettlement={agreementFinalSettlement}
                        isInvestmentEffectiveFootageFilled={isInvestmentEffectiveFootageFilled}
                        agreementKind={agreementKind}
                        products={products}
                        readOnly={readOnly}
                        sx={{ml: 2}}
                    />
                             
                </Grid>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, mx: "auto", overflowY: "auto", maxHeight: "40vh" }} >
                        <AgreementProductsReckoningTable products={products} agreementFinalSettlement={agreementFinalSettlement} showTotalsAfterDiscount={true}/>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    );
};
